// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subscribers-list-wrapper[data-v-0ff6956f]{top:40px}.subscribers-wrapper[data-v-0ff6956f]{min-width:300px}.amount-wrapper[data-v-0ff6956f]{font-size:12px}.damage-claim-dropdown[data-v-0ff6956f] .dropdown-toggle{width:100%}", ""]);
// Exports
module.exports = exports;
